import React from 'react'
import ContentHeader from '@Components/ContentHeader'

const RegistrationQuestionnaireHeader = () => (
    <div className="rightsholder-registration-scene-header">
        <ContentHeader
            title="New Member Survey Questions"
            descriptionElement={<p>Below, please tell us a little more about your catalog.</p>}
        />
    </div>
)

export default RegistrationQuestionnaireHeader
